import {
  IconButton,
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
  Tooltip,
} from "@chakra-ui/react";
import { FaQuestion, FaQuestionCircle, FaUsers, FaVideo } from "react-icons/fa";
import { useTranslation } from "react-i18next";

import { openUrl, SIMPLIFIED_ACADEMY_LINK, SIMPLIFIED_HELP_CENTRE_LINK, SIMPLIFIED_OFFICIAL_COMMUNITY_LINK } from "@simplified-workspace/shared/util";

const menuStyle = {
  _hover: {
    background: "gray.1000",
  },
  _active: {
    background: "gray.1000",
  },
};

function TldrHelpAndSupportMenu() {
  const { t } = useTranslation(["navbar"]);

  return (
    <Menu autoSelect={false}>
      <Tooltip label={t("help_and_support.title")} hasArrow>
        <MenuButton
          sx={menuStyle}
          as={IconButton}
          aria-label="Options"
          borderRadius="full"
          icon={<FaQuestionCircle />}
          variant="ghost"
          size="sm"
          fontSize="lg"
        />
      </Tooltip>

      <MenuList>
        <MenuGroup title={t("help_and_support.title")}>
          <MenuItem
            onClick={() => openUrl(SIMPLIFIED_ACADEMY_LINK)}
            icon={<FaVideo />}
          >
            {t("help_and_support.academy")}
          </MenuItem>
          <MenuItem
            onClick={() => openUrl(SIMPLIFIED_OFFICIAL_COMMUNITY_LINK)}
            icon={<FaUsers />}
          >
            {t("help_and_support.community")}
          </MenuItem>
          <MenuItem
            onClick={() => openUrl(SIMPLIFIED_HELP_CENTRE_LINK)}
            icon={<FaQuestion />}
          >
            {t("help_and_support.help_center")}
          </MenuItem>
        </MenuGroup>
      </MenuList>
    </Menu>
  );
}

export default TldrHelpAndSupportMenu;
